<template>
    <div class="mb-2 mt-0 pl-0 pt-0" style="">
        <data-grid
            class="family-missing-boxes"
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            ref="grid"
            :hideHeader="true"
            :selectionEnabled="true"
        ></data-grid>
    </div>
</template>
<script>
import moment from "moment";
import { formatPhoneNumber } from "../../utils/helpers.js";

export default {
    props: {
        route: Object,
        distributionID: Number,
        createBoxes: Function,
    },
    data() {
        return {
            title: "Families Missing Boxes",
            columns: [
                {
                    sortable: false,
                    label: "Family ID",
                    field: "familyID",
                    link: "Account View",
                    width: "220px",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Name",
                    field: "name",
                    width: "250px",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: false,
                    label: "Hebrew Name",
                    field: "nameH",
                    width: "250px",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Small Boxes",
                    field: "smallBoxes",
                    type: "number",
                    hidden: true,
                    width: "200px",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Large Boxes",
                    field: "largeBoxes",
                    type: "number",
                    hidden: true,
                    width: "200px",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Enrolled",
                    field: "enrolled",
                    type: "number",
                    hidden: true,
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Bus Address 1",
                    field: "busAddress1",
                    width: "250px",
                    sortable: false,
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Bus House",
                    field: "busHouse",
                    width: "250px",
                    sortable: true,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Bus Apt",
                    field: "busApt",
                    width: "250px",
                    sortable: true,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Bus State",
                    field: "busState",
                    width: "200px",
                    sortable: false,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Bus Street",
                    field: "busStreet",
                    width: "250px",
                    sortable: true,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Street Side",
                    field: "streetSide",
                    width: "200px",
                    sortable: false,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    sortable: true,
                    label: "Enrolled Date",
                    field: "enrolledDate",
                    type: "date",
                    width: "150px",
                    dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                    hidden: false,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Route Sort",
                    field: "routeSort",
                    width: "250px",
                    sortable: true,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Label Batch",
                    field: "labelBatch",
                    width: "250px",
                    sortable: false,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    label: "Box Note",
                    field: "boxNote",
                    width: "200px",
                    sortable: false,
                    hidden: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
            ],

            actions: [],
        };
    },
    async created() {
        this.url =
            "foodDistributionMissingBoxes?distributionID=" +
            this.distributionID +
            "&route=" +
            this.route.route;

        this.actions.push({
            text: "Create Boxes",
            action: this.createBoxes,
            showOnSelection: true,
        });
    },
    computed: {},
    methods: {
        onRowClicked(row) {},
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
    },
};
</script>
<style>
.family-missing-boxes.container {
    padding-left: 0px !important;
    padding-bottom: 0px !important;
}
.family-missing-boxes .flex {
    padding: 0px !important;
}
.family-missing-boxes .per-page {
    margin-top: 16px !important;
}
.family-missing-boxes .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
